import { PropsWithChildren, ReactNode } from "react"

export const DetailsRow = ({ title, children }: PropsWithChildren<{ title: ReactNode }>) => {
  if (children == null || children.toString().length === 0) return null
  return (
    <div className="text-sm">
      {typeof title == "string" ? <strong>{title}</strong> : title} <span>{children}</span>
    </div>
  )
}
